import { motion } from "framer-motion";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS, PROCESS_STEPS } from "@/lib/site";

export const Process = () => (
    <section id="come-funziona" className="scroll-mt-20 border-b-2 border-ink bg-cream">
        <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:py-24">
            <motion.div
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.5 }}
                className="max-w-3xl"
            >
                <p className="mb-4 inline-block border-2 border-ink bg-white px-3 py-1 text-xs font-bold uppercase tracking-widest">
                    Come funziona
                </p>
                <h2 className="headline-display text-4xl font-bold sm:text-5xl">
                    Quattro passi, zero complicazioni
                </h2>
            </motion.div>
            <ol className="mt-12 grid gap-6 md:grid-cols-2 xl:grid-cols-4">
                {PROCESS_STEPS.map((s, i) => (
                    <motion.li
                        key={s.title}
                        initial={{ opacity: 0, y: 24 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{ duration: 0.5, delay: i * 0.08 }}
                        data-testid={`process-step-${i + 1}`}
                        className="relative h-full border-2 border-ink bg-white p-6 pt-10"
                    >
                        <span className="absolute -top-5 left-5 border-2 border-ink bg-royal px-3 py-1 font-display text-xl font-bold text-white">
                            {i + 1}
                        </span>
                        <h3 className="font-display text-xl font-semibold uppercase tracking-tight">
                            {s.title}
                        </h3>
                        <p className="mt-2 text-sm font-medium leading-relaxed text-ink/75">
                            {s.text}
                        </p>
                    </motion.li>
                ))}
            </ol>
        </div>
    </section>
);

export const Faq = () => (
    <section id="faq" className="scroll-mt-20 border-b-2 border-ink bg-white">
        <div className="mx-auto max-w-4xl px-4 py-20 sm:px-6 lg:py-24">
            <motion.div
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.5 }}
            >
                <p className="mb-4 inline-block border-2 border-ink bg-cream px-3 py-1 text-xs font-bold uppercase tracking-widest">
                    Domande frequenti
                </p>
                <h2 className="headline-display text-4xl font-bold sm:text-5xl">
                    Quello che chiedono tutti
                </h2>
            </motion.div>
            <motion.div
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.5, delay: 0.1 }}
                className="mt-10"
            >
                <Accordion type="single" collapsible className="w-full">
                    {FAQS.map((f, i) => (
                        <AccordionItem
                            key={f.q}
                            value={`faq-${i}`}
                            className="border-b-2 border-ink"
                        >
                            <AccordionTrigger
                                data-testid={`faq-trigger-${i}`}
                                className="py-5 text-left font-display text-lg font-semibold uppercase tracking-tight hover:text-royal hover:no-underline"
                            >
                                {f.q}
                            </AccordionTrigger>
                            <AccordionContent
                                data-testid={`faq-content-${i}`}
                                className="text-base font-medium leading-relaxed text-ink/80"
                            >
                                {f.a}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </motion.div>
        </div>
    </section>
);
